/*
  shani-brand-page.js (07.10.2026, מותגים, חבילה B3). נטען רק בעמוד מותג, מ-sections/shani-brand-page (defer).
  ממלא שני אזורים שהמקום שלהם כבר שמור ב-HTML (is-loading), כשהם מתקרבים לתצוגה:
    1. שורת ההמשך של מותג קטן: /products/<handle>?section_id=shani-product-rows (המנגנון של דף המוצר, בקשה אחת).
       לוקחים את שורת "עוד במידה" (כשיש לפריט מידה), ואם אין בה 2 כרטיסים: את שורת הקטגוריה.
       כרטיס של פריט שכבר מוצג בעמוד (אותו מותג) יורד. פחות מ-2 כרטיסים, סוג שונה מהצפוי, או שגיאה: האזור כולו יורד.
    2. מותגים נוספים: /collections/all?section_id=shani-brand-more. המותג של העמוד יורד, עד 8 צ'יפים. אין צ'יפים או שגיאה: האזור יורד.
  בלי jQuery. ריצה שנייה של הקובץ (או של init) לא עושה כלום.
*/
(function () {
  'use strict';
  if (window.__shaniBrandPage) return;
  window.__shaniBrandPage = true;

  var MAX_CARDS = 8;
  var MAX_CHIPS = 8;

  function withPreview(url) {
    var m = /[?&]preview_theme_id=(\d+)/.exec(window.location.search);
    if (!m) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + m[1];
  }

  function getDoc(url) {
    return fetch(withPreview(url), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (t) {
        return new DOMParser().parseFromString(t, 'text/html');
      });
  }

  function whenNear(el, cb) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { io.disconnect(); cb(); return; }
      }
    }, { rootMargin: '600px 0px' });
    io.observe(el);
  }

  function drop(box) {
    box.hidden = true;
    box.classList.remove('is-loading');
  }

  function show(box) {
    box.classList.remove('is-loading');
  }

  function readHandles(root) {
    var set = {};
    try {
      var arr = JSON.parse(root.getAttribute('data-handles') || '[]');
      for (var i = 0; i < arr.length; i++) set[String(arr[i])] = true;
    } catch (e) { /* רשימה לא תקינה: לא מסננים */ }
    return set;
  }

  function loadCont(root, box) {
    var row = box.querySelector('[data-shbp-row]');
    var url = box.getAttribute('data-url');
    if (!row || !url) { drop(box); return; }
    var shown = readHandles(root);
    getDoc(url).then(function (doc) {
      var wrap = doc.querySelector('[data-shp-rows]');
      if (!wrap || wrap.getAttribute('data-type') !== box.getAttribute('data-type')) { drop(box); return; }
      var keys = box.hasAttribute('data-has-size') ? ['size', 'cat'] : ['cat'];
      var picked = null;
      var pickedKey = '';
      for (var k = 0; k < keys.length && !picked; k++) {
        var title = box.querySelector('[data-shbp-t="' + keys[k] + '"]');
        var strip = wrap.querySelector('.shp-strip--' + keys[k]);
        if (!title || !strip) continue;
        var all = strip.querySelectorAll('a.shp-card');
        var cards = [];
        for (var i = 0; i < all.length && cards.length < MAX_CARDS; i++) {
          var h = all[i].getAttribute('data-h') || '';
          if (h && shown[h]) continue;
          cards.push(all[i]);
        }
        if (cards.length >= 2) { picked = cards; pickedKey = keys[k]; }
      }
      if (!picked) { drop(box); return; }
      var frag = document.createDocumentFragment();
      for (var c = 0; c < picked.length; c++) frag.appendChild(document.importNode(picked[c], true));
      row.textContent = '';
      row.appendChild(frag);
      box.querySelector('[data-shbp-t="' + pickedKey + '"]').hidden = false;
      box.setAttribute('data-shbp-shown', pickedKey);
      show(box);
    }).catch(function () { drop(box); });
  }

  function loadMore(root, box) {
    var list = box.querySelector('[data-shbp-chips]');
    var url = box.getAttribute('data-url');
    if (!list || !url) { drop(box); return; }
    var brand = (root.getAttribute('data-brand') || '').trim().toUpperCase();
    getDoc(url).then(function (doc) {
      var all = doc.querySelectorAll('a.shb-chip[data-vendor]');
      var chips = [];
      for (var i = 0; i < all.length && chips.length < MAX_CHIPS; i++) {
        var v = (all[i].getAttribute('data-vendor') || '').trim().toUpperCase();
        if (!v || v === brand) continue;
        chips.push(all[i]);
      }
      if (!chips.length) { drop(box); return; }
      var styles = doc.querySelectorAll('[data-shbm] style');
      for (var s = 0; s < styles.length; s++) box.insertBefore(document.importNode(styles[s], true), box.firstChild);
      var frag = document.createDocumentFragment();
      for (var c = 0; c < chips.length; c++) frag.appendChild(document.importNode(chips[c], true));
      list.insertBefore(frag, list.firstChild);
      show(box);
    }).catch(function () { drop(box); });
  }

  function init() {
    var root = document.querySelector('[data-shbp]');
    if (!root || root.hasAttribute('data-shbp-on')) return;
    root.setAttribute('data-shbp-on', '');
    var cont = root.querySelector('[data-shbp-cont]');
    var more = root.querySelector('[data-shbp-more]');
    if (cont) whenNear(cont, function () { loadCont(root, cont); });
    if (more) whenNear(more, function () { loadMore(root, more); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
